import { initializeApollo } from 'gql/client'
import { NextWrapper } from 'data-fetching-wrapper'
import { CategoriaHelpOnlineDetailNode, CategoriaHelpOnlineDocument } from '@gql/graphql'
import CategoriaFaqTemplate from '@components/templates/CategoriaFaqTemplate/CategoriaFaqTemplate'

interface Props {
  categoriaHelpOnline?: CategoriaHelpOnlineDetailNode
  faqOpened?: string
}

const CategoriaHelpOnlinePage = ({ categoriaHelpOnline, faqOpened }: Props) => {
  return (
    <CategoriaFaqTemplate
      pagina={categoriaHelpOnline?.categoria?.pagina}
      categoriaFaq={categoriaHelpOnline?.categoria}
      categorieFaq={categoriaHelpOnline.categorie}
      faqOpened={faqOpened}
      key={categoriaHelpOnline?.categoria?.pk}
    />
  )
}

export const getStaticPaths = NextWrapper.getStaticPaths(
  async () => ({
    paths: [],
    fallback: 'blocking',
  }),
  '/help-online/[slug]'
)

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug }, preview, previewData, locale }) => {
    const client = initializeApollo(locale)
    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { categoriaHelpOnline },
    } = await client.query({
      query: CategoriaHelpOnlineDocument,
      variables: {
        categoriaSlug: slug[0],
      },
    })

    if (!categoriaHelpOnline || !categoriaHelpOnline.categoria.risposte.length) {
      return {
        notFound: true,
      }
    }

    return {
      props: {
        categoriaHelpOnline: categoriaHelpOnline,
        faqOpened: slug.length > 1 ? slug[1] : null,
      },
      revalidate: 60 * 20,
    }
  },
  '/help-online/[slug]'
)

export default CategoriaHelpOnlinePage
